import React from 'react';
import classNames from 'classnames';

export interface FooterNavProps {
  children?: React.ReactNode;
  className?: string;
  /**
   * Labels should be unique to each instance of this nav.
   * This is currently optional to not introduce a breaking change.
   */
  label?: string;
}

export const FooterNav = ({ children, className, label = 'Footer navigation' }: FooterNavProps): JSX.Element => {
  const footerNavClasses = classNames(className, 'ver-footer__nav');
  return (
    <nav className={footerNavClasses} aria-label={label}>
      <ul>
        {React.Children.map(children, (child) => {
          return <li className="ver-footer--item">{child}</li>;
        })}
      </ul>
    </nav>
  );
};
